import { Card as _Card, CardProps as _CardProps } from "reactstrap";

export const Card = _Card;
export type CardProps = _CardProps;
